var Access = {};
Access.install = function (Vue, options) {
	// 1. add global method or property
	Vue.prototype.$canAccess = function (permission, subpermission) {
		var state = false;
		for(var p in this.$store.getters.getUserRoles){
			if(p == permission){
				if(subpermission){
					if(!this.$store.getters.getUserRoles[p].rolesPermissions.hasOwnProperty(subpermission)) continue;
					if(this.$store.getters.getUserRoles[p].rolesPermissions[subpermission].state) state = true;
				} else {
					var roleCat = this.$store.getters.getUserRoles[p];
					for(var role_id in rol_cat){
						if(!roleCat.rolesPermissions.hasOwnProperty(role_id)) continue;
						if(roleCat.rolesPermissions[role_id].state) state = true;
					}

				}

			}
		}
		return state;
	}
}


export default Access;


// WEBPACK FOOTER //
// ./src/plugins/Access.js